module.exports = require('./dist/circos.es6');
